import React, {useState} from 'react';
import {makeStyles} from "@mui/styles";
import {TextField} from "@mui/material";
import {useI18n} from "../../i18n/I18nContext";

const useStyles = makeStyles({
    root: {
        marginTop: 20,
        display: "flex",
        justifyContent: "flex-end"
    }
});

interface Props {
    readonly onSearch: (value: string) => void
}

export function IntegrationsSearch({onSearch}:Props) {
    const [value, setValue] = useState("");
    const {translate} = useI18n();
    const classes = useStyles();
    return (
        <form className={classes.root} onSubmit={e => {
            e.preventDefault();
            onSearch(value)
        }}>
            <TextField
                sx={{maxWidth: 320, width: "100%"}}
                name="search"
                id="demo_search"
                type="search"
                placeholder={translate("SEARCH_HERE")}
                value={value}
                onChange={(e: any) => {
                    setValue(e.target.value);
                    if (e.target.value.length === 0) {
                        onSearch(e.target.value)
                    }
                }}
            />
        </form>
    );
}

